export default __webpack_public_path__ + "static/network-1-2a2835ca77d9abfa596360d84f7703ea.png";